import React from 'react';
import styles from './styles.module.css';

const Pricing = () => {
  return <div className={styles.headingStyles}>coming soon pricing</div>;
};

export default Pricing;
